import React, { useEffect, useRef } from "react";
import { isPropertySignature } from "typescript";
import "./counter.block.scss";

interface Props {
  title: string;
}

const Counter: React.FC<Props> = (props) => {
  const date = new Date("2022-06-23T19:00:00.000+02:00");
  const dateTime = date.getTime();

  const [time, setTime] = React.useState(0);

  useEffect(() => {
    const calculateDelta = () => {
      const dateNow = Date.now();
      let delta = (dateTime - dateNow) / 1000;
      if (delta < 0) {
        delta = 0;
      }
      setTime(delta);
    };
    const timer = setInterval(calculateDelta, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [time]);

  let delta = time;

  // calculate (and subtract) whole days
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  // calculate (and subtract) whole hours
  var hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;
  hours += days * 24;

  const hoursArr = hours.toString().padStart(2, "0").split("");
  // calculate (and subtract) whole minutes
  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;
  const minutesStr = minutes.toString();
  const minutesLeadZ = minutesStr.padStart(2, "0");
  const minutesArr = minutesLeadZ.split("");
  // what's left is seconds
  const seconds = Math.floor(delta % 60); // in theory the modulus is not required
  const secondsStr = seconds.toString();
  const secondsLeadZ = secondsStr.padStart(2, "0");
  const secondsArr = secondsLeadZ.split("");
  //   console.log(seconds);

  return (
    <div className="counter">
      <div className="counter__wrapper">
        <h5 className="counter__title">{props.title}</h5>
        <div className="counter__numbers">
          {/* HOURS */}
          {hoursArr.map((item, key) => (
            <span className="counter-time" key={key}>
              {item}
            </span>
          ))}
          <span className="counter-time__divider">:</span>
          {/* MINUTES */}
          {minutesArr.map((item, key) => (
            <span className="counter-time" key={key}>
              {item}
            </span>
          ))}
          <span className="counter-time__divider">:</span>
          {/* SECONDS */}
          {secondsArr.map((item, key) => (
            <span className="counter-time" key={key}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Counter;
